/** 跨域消息通讯 */

import { createIframe } from './iframe';

/**
 * 传递消息
 *
 * @export
 * @param {object} data 
 */
export function postMessage(data) {
  let iframNode = document.getElementById('message_iframe');
  if (iframNode) {
    iframNode.contentWindow.postMessage(data, '*');
  } else {
    iframNode = createIframe('message_iframe', '//st.moneydata.hk/res/util/message.html');
    document.body.appendChild(iframNode);
    iframNode.onload = () => {
      iframNode.contentWindow.postMessage(data, '*');
    }
  }
}

/**
 * 收取消息
 *
 * @export
 * @returns
 */
export function addListenMessage() {
  let promise = new Promise(function (resolve, reject) {
    window.addEventListener(
      'message',
      function (e) {
        const origin = e.origin;
        if (/moneydata\.hk/.test(origin) || /wechatpay\.com\.hk/.test(origin)) {
          resolve(e.data);
        }
      },
      false
    );
  });
  return promise;
}